import { Injectable } from "@angular/core";

import { Api, User } from "../";

@Injectable()
export class Master {
  constructor(public api: Api, public user: User) {}

  getCondition(params?: any) {
    return this.api.get("index.php/asset/master/condition", params);
  }

  getClassification(params?: any) {
    return this.api.get("index.php/asset/master/classification", params);
  }

  saveClassification(params?: any) {
    return this.api.post("index.php/asset/master/classification", params);
  }

  getLocation(params?: any) {
    return this.api.get("index.php/asset/master/location", params);
  }

  saveLocation(params?: any) {
    return this.api.post("index.php/asset/master/location", params);
  }

  getAsset(params?: any) {
    return this.api.get("index.php/asset/master/asset", params);
  }

  getCompany(params?: any) {
    return this.api.get("index.php/asset/master/company", params);
  }

  getDepartment(params?: any) {
    return this.api.get("index.php/asset/master/departemen", params);
  }

  getProject(params?: any) {
    return this.api.get("index.php/asset/master/project", params);
  }

  getBaseQR(params?: any) {
    return this.api.get("index.php/asset/master/base64qrcode", params);
  }

  getAbout(params?: any) {
    return this.api.get("index.php/asset/master/about", params);
  }

  getVendor(params?: any) {
    return this.api.get("index.php/asset/master/vendor", params);
  }

  postVendor(params: any) {
    if (params.id == "" || params.id == undefined) {
      params.created_by = this.user.data.employee_id;
    } else {
      params.updated_by = this.user.data.employee_id;
    }
    return this.api.post("index.php/asset/master/vendor", params);
  }

  getMasterVendor(params?: any) {
    return this.api.get("index.php/asset/master/vendorMaster", params);
  }
}



// WEBPACK FOOTER //
// ./src/providers/asset/master/master.ts